import { createSelector } from 'reselect';
//////////////////////////////////////////////////

const selectMailSendingStore = (state) => state.mailSending;

const makeSelectMailSending = () => createSelector(
  selectMailSendingStore,
  ({ mailSend }) => mailSend,
);

const makeSelectContactList = () => createSelector(
  selectMailSendingStore,
  ({ contactList }) => contactList,
);

export { makeSelectMailSending, makeSelectContactList };
